import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

if (!BACKEND_URL) {
  // Fail loud during dev if env missing
  // eslint-disable-next-line no-console
  console.error("REACT_APP_BACKEND_URL is not set");
}

export const API = `${BACKEND_URL}/api`;

export const TOKEN_KEY = "signalagent_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const api = axios.create({
  baseURL: API,
  timeout: 15000,
});

// Attach bearer token on every request
api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers = { ...config.headers, Authorization: `Bearer ${token}` };
  }
  return config;
});

// Normalise FastAPI error detail → string
export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || "Une erreur est survenue. Réessaie.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" — ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
